document.addEventListener( 'DOMContentLoaded', ( event ) => {
	let webhookInput = document.getElementById(
			'learn_press_sepay[webhook_url]'
		),
		apikeyInput = document.getElementById( 'learn_press_sepay[api_key]' );
	webhookInput.insertAdjacentHTML(
		'afterend',
		`
		<button type="button" class="button-primary lp-sepay-btn-copy">Copy<span class="dashicons dashicons-admin-page" style="margin-top: 4px;"></span></button>`
	);
	apikeyInput.insertAdjacentHTML(
		'afterend',
		`
		<button type="button" class="button-primary lp-sepay-btn-copy">Copy<span class="dashicons dashicons-admin-page" style="margin-top: 4px;"></span></button>
		<button type="button" class="button-secondary lp-sepay-btn-generate-key">Generate<span class="dashicons dashicons-plus" style="margin-top: 4px;"></span></button>`
	);
	const generateApiKey = ( length ) => {
		const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
		const numbers = '0123456789';
		let result = '';
		result += numbers.charAt(
			Math.floor( Math.random() * numbers.length )
		);
		// Fill the rest with random characters
		const chars = letters + numbers;
		for ( let i = 1; i < length; i++ ) {
			result += chars.charAt(
				Math.floor( Math.random() * chars.length )
			);
		}
		// Shuffle the string
		return result
			.split( '' )
			.sort( () => Math.random() - 0.5 )
			.join( '' );
	};
	const copyText = ( inputEle ) => {
		inputEle.select();
		inputEle.setSelectionRange( 0, 99999 );
		// navigator.clipboard.writeText(inputEle.value);

		if ( navigator.clipboard === undefined ) {
			document.execCommand( 'copy' );
		} else {
			navigator.clipboard.writeText( inputEle.value );
		}
	};
	document.addEventListener( 'click', ( e ) => {
		let target = e.target;
		if ( target.classList.contains( 'lp-sepay-btn-copy' ) ) {
			// console.log(target.closest('td').querySelector( '.lp-sepay-btn-copy' ) );
			copyText( target.closest( 'td' ).querySelector( 'input' ) );
		} else if ( target.classList.contains( 'lp-sepay-btn-generate-key' ) ) {
			const key = generateApiKey( 24 );
			apikeyInput.value = key;
		}
	} );
} );
